import {V3Person, V3PersonDetails} from "../../model/v3/people";

export class PersonUtils {
  static getPersonName(
    person: V3PersonDetails
  ): string {
    const fullName: string[] = [];
    if (person.name != null) fullName.push(person.name);
    if (person.surname != null) fullName.push(person.surname);
    return fullName.join(' ');
  }

  static getInitials(person: V3PersonDetails) {
    if (!person) {
      return '';
    }
    const nameComponents: string[] = [];
    if (person.name) {
      nameComponents.push(person.name);
    }
    if (person.surname) {
      nameComponents.push(person.surname);
    }
    return nameComponents.map(part => {
      return part[0]
    }).join('').toUpperCase()
  }

  static getName(person: V3Person) {
    const components = [];
    if (person.details.name) components.push(person.details.name);
    if (person.details.surname) components.push(person.details.surname);
    return components.join(" ");
  }
}
